export default {
  signUpSuccess: 'Succesfully registered! You\'ve been signed in as well.',
  signUpFailure: 'Registration failed. Email may be taken, or passwords don\'t match.',
  signInSuccess: 'Welcome!',
  signInFailure: 'Failed to sign in. Check your email and password and try again.',
  signOutSuccess: 'Come back soon!',
  changePasswordSuccess: 'Password changed successfully!',
  changePasswordFailure: 'Failed to change passwords. Check your old password and try again.',
  createEventSuccess: 'Event Created Successfully',
  createEventFailure: 'Failed to Create Event',
  updateEventSuccess: 'Event Updated Successfully',
  updateEventFailure: 'Failed to Update Event',
  deleteEventSuccess: 'Event Deleted Succesfully',
  deleteEventFailure: 'Failed to Delete Event'
}



// WEBPACK FOOTER //
// ./src/components/AutoDismissAlert/messages.js